import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from '@material-ui/core/Tooltip';
import GridContainer from "components/Grid/GridContainer.jsx";
import { EmptyRecord } from "../../utils/PageUtility";
import GridItem from "components/Grid/GridItem.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination  from "../../utils/RecordsPagination";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import Approve from "@material-ui/icons/Done";
import Decline from "@material-ui/icons/Close";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import {appHelpers} from "../../_helpers";
import { PrimaryLabel, DefaultLabel, DangerLabel } from "../../utils/LabelPanel"
import {appConstants} from "../../_constants";
const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  tableStyle: {
    padding: 0
  }
};

const TableStructure = ({classes, records, handleApproval, handleApprovalModal, handleViewRouteModal, filterUsers, user, pageIndex}) => (
    <Table className={classes.table} aria-labelledby="tableTitle">
        <TableHead className={classes.negativeColor} color="primary">
            <TableRow>
                <TableCell>S/N</TableCell>
                <TableCell>Airline</TableCell>
                <TableCell>Routes</TableCell>
                <TableCell>Created By</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {records.map((item, key) => {
                return (
                    <TableRow hover key={key}>
                        <TableCell>{pageIndex + key}</TableCell>
                        <TableCell className={'text-capitalize'}>{item.Airline}</TableCell>
                        <TableCell component="th">
                            {item.Routes.length}
                        </TableCell><TableCell component="th">
                            {`${filterUsers(item.CreatedBy)}`}
                        </TableCell>
                        <TableCell>{ appHelpers.formatDateSpecific(
                            item.DateSubmitted,
                            "MMM DD, YYYY"
                        )}
                        </TableCell>
                        <TableCell>
                            {
                                item.Status === 0 &&
                                    <DefaultLabel message={'Pending'}/>
                            }
                            {
                                item.Status === 1 &&
                                <PrimaryLabel message={'Approved'}/>
                            }
                            {
                                item.Status === 2 &&
                                <DangerLabel message={'Rejected'}/>
                            }
                        </TableCell>
                        <TableCell>
                             <span style={{ cursor: "pointer" }} onClick={() => handleViewRouteModal(item)}>
                                 <Tooltip title="View" placement="top">
                                         <span className={classes.icon}><ViewIcon /></span>
                                     </Tooltip>
                             </span>
                            <br/>
                            {item.CreatedBy !== user.userId && item.Status === 0
                                ?
                                <span>
                                     <Tooltip title="Approve" placement="top">
                                        <span className={classes.icon} style={{color: `${appConstants.PRIMARY_COLOR}`, cursor: 'pointer'}} onClick={() => handleApprovalModal(appConstants.AIRLINE_ROUTE_APPROVE, item)}><Approve/></span>
                                     </Tooltip>
                                    <br/>
                                     <Tooltip title="Decline" placement="top">
                                        <span className={classes.icon} style={{color: `${appConstants.DANGER_COLOR}`, cursor: 'pointer'}} onClick={() => handleApprovalModal(appConstants.AIRLINE_ROUTE_REJECT, item)}><Decline/></span>
                                     </Tooltip>
                                </span>
                                : ''
                            }

                            {/*<i onClick={handleApproval}>Actions</i>*/}
                        </TableCell>
                    </TableRow>
                );
            })}
        </TableBody>
    </Table>
);

class RecordsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false
    };
  }

  handleClickOpen = (flight) => {
    this.setState({ open: true });
    this.setState({flight});
    this.props.fetchFlightPassengers(flight.Id);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  printFlightData = () => {};

  downloadFlightData = () => {};

  render() {
    const { classes, totalCounts,
        records, handleSearch,
        currentPage, pageSize,
        handleApproval,
        handleApprovalModal,
        handleViewRouteModal,
        filterUsers,
        user
    } = this.props;
      const pageIndex = (pageSize * (currentPage - 1)) + 1;
      return (
      <div>
          {
              totalCounts !== 0
              &&
              <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
                  <RecordPagination
                      fetchMore={handleSearch} totalCount={totalCounts}
                      pageSize={pageSize} currentPage={currentPage}
                      target={<TableStructure classes={classes} pageIndex={pageIndex} handleViewRouteModal={handleViewRouteModal} handleApproval={handleApproval} handleApprovalModal={handleApprovalModal} filterUsers={filterUsers} user={user} records={records}/>}
                  />
              </div>
          }
          {
              totalCounts === 0
              &&
              <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                      <EmptyRecord message={'No airline route record.'}/>
                  </GridItem>
              </GridContainer>
          }
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(RecordsTable));



// WEBPACK FOOTER //
// ./src/views/AirlineRouteSettings/RecordsTable.jsx